import { gql } from '@apollo/client';

export const PAGINATE_GLUCOSE = gql`
    query PaginateGlucose(
        $first: Int!
        $page: Int!
        $search: String
        $filters: String
    ) {
        paginateGlucoseRegister(
            first: $first
            page: $page
            search: $search
            filters: $filters
        ) {
            paginatorInfo {
                count
                currentPage
                firstItem
                perPage
                lastItem
                total
            }
            data {
                id
                name
                cpf
                phone
                registration_number
                state
                created_at
            }
        }
    }
`;

export const GET_GLUCOSE = gql`
    query GetGlucose(
        $id: String!
        $cpf: String
    ) {
        getGlucose(
            id: $id
            cpf: $cpf
        ) {
            id
            name
            cpf
            phone
            registration_number
            state
            life_id
            created_at
            glucose_monitoring {
                glucose_value
                date
                time
                status
                gestational_age
                weight
                observation
                created_at
            }
        }
    }
`;


export const GET_GLUCOSE_REGISTRATION = gql`
    query GetGlucoseByRegistration(
        $registration_number: String!
        $cpf: String
    ) {
        getGlucose(
            registration_number: $registration_number
            cpf: $cpf
        ) {
            glucose_monitoring {
                glucose_value
                date
                time
                status
                gestational_age
                weight
                observation
                created_at
            }
        }
    }
`;

export const POST_GLUCOSE_VALIDATE = gql`
	mutation GlucoseValidate($input: GlucoseValidateInput!) {
		glucoseValidate(input: $input) {
            exists
        }
	}
`;

export const POST_GLUCOSE_REGISTER = gql`
	mutation GlucoseRegister($input: GlucoseRegisterInput!) {
		glucoseRegister(input: $input)
	}
`;

export const POST_GLUCOSE_MONITORING = gql`
	mutation GlucoseMonitoring($input: GlucoseMonitoringInput!) {
		glucoseMonitoring(input: $input)
	}
`;

export const SEND_GLUCOSE_LINK = gql`
	mutation GlucoseLink($id: String!) {
		glucoseLink(id: $id)
	}
`;